export default function FieldMapping( { mapping, onChange, cf7Fields } ) {
	const addRow = () => onChange( [ ...mapping, { cf7_field: '', webhook_key: '' } ] );

	const updateRow = ( index, key, value ) => {
		const next = mapping.map( ( row, i ) =>
			i === index ? { ...row, [ key ]: value } : row
		);
		onChange( next );
	};

	const removeRow = ( index ) => onChange( mapping.filter( ( _, i ) => i !== index ) );

	return (
		<div className="rtwc-section">
			<p className="description rtwc-section-desc">
				Map CF7 form fields to the keys that will be sent in the webhook payload.
				If no mapping is defined, all form data will be sent as-is.
			</p>

			{ mapping.length > 0 ? (
				<table className="wp-list-table widefat striped rtwc-mapping-table">
					<thead>
						<tr>
							<th>CF7 Field</th>
							<th>Webhook Key</th>
							<th style={ { width: 80 } }></th>
						</tr>
					</thead>
					<tbody>
						{ mapping.map( ( row, i ) => (
							<tr key={ i }>
								<td>
									<select
										value={ row.cf7_field }
										onChange={ ( e ) => updateRow( i, 'cf7_field', e.target.value ) }
									>
										<option value="">— Select Field —</option>
										{ cf7Fields.map( ( f ) => (
											<option key={ f } value={ f }>{ `[${ f }]` }</option>
										) ) }
										{ ! cf7Fields.includes( row.cf7_field ) && row.cf7_field && (
											<option value={ row.cf7_field }>{ row.cf7_field }</option>
										) }
									</select>
								</td>
								<td>
									<input
										type="text"
										className="regular-text"
										value={ row.webhook_key }
										placeholder="e.g. email_address"
										onChange={ ( e ) => updateRow( i, 'webhook_key', e.target.value ) }
									/>
								</td>
								<td>
									<button
										type="button"
										className="button rtwc-remove-btn"
										onClick={ () => removeRow( i ) }
										title="Remove row"
									>
										✕
									</button>
								</td>
							</tr>
						) ) }
					</tbody>
				</table>
			) : (
				<div className="rtwc-empty-table">
					<em>No field mapping defined – all CF7 data will be forwarded.</em>
				</div>
			) }

			<p>
				<button type="button" className="button button-secondary" onClick={ addRow }>
					+ Add Mapping Row
				</button>
			</p>

			{ ! cf7Fields.length && (
				<p className="rtwc-hint">
					⚠ Select a CF7 Form in the <strong>Details</strong> tab to populate field options.
				</p>
			) }
		</div>
	);
}
